<template>
  <div class="c-mobile-nav__item">
    <a
      :href="computedHref"
      class="c-button c-mobile-nav__action"
      v-bind="popupTriggerAttrs"
    >
      <slot />
    </a>
  </div>
</template>

<script>
export default {
  name: "VMobileNavAction",
  props: {
    url: {
      type: String,
      required: true,
    },
    popupTrigger: { type: Boolean, default: false }, // triggers popup if true
    popupTargetId: { type: String, default: null }, // the ID of the popup to open
  },
  computed: {
    popupTriggerAttrs() {
      if (!this.popupTrigger || !this.popupTargetId) return {};
      return {
        "aria-controls": this.popupTargetId,
        "data-open-popup": "",
      };
    },
    computedHref() {
      return this.popupTrigger && this.popupTargetId ? "" : this.url;
    },
  },
};
</script>
